import { render, staticRenderFns } from "./RHViajePeriodicidades.vue?vue&type=template&id=c2866236&scoped=true"
import script from "./RHViajePeriodicidades.vue?vue&type=script&lang=js"
export * from "./RHViajePeriodicidades.vue?vue&type=script&lang=js"
import style0 from "./RHViajePeriodicidades.vue?vue&type=style&index=0&id=c2866236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2866236",
  null
  
)

export default component.exports